import React, { useState, useRef } from "react";
import axios from "axios";
import { Volume2, Loader2 } from "lucide-react"; // Lucide for icons

const SpeakerButton = ({ text }) => {
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(1.0); // Default volume
  const audioRef = useRef(null);

  // Function to remove anything inside < ... >
  const cleanText = (input) => input.replace(/<[^>]*>/g, "...").trim();

  const handlePlay = async () => {
    if (!text) return;
    setLoading(true);

    try {
      const processedText = cleanText(text); // Preprocess text

      const response = await axios.post(
        "/api/speak",
        { text: processedText },
        { responseType: "blob" }
      );

      const audioUrl = URL.createObjectURL(new Blob([response.data], { type: "audio/mpeg" }));
      const audio = new Audio(audioUrl);
      audioRef.current = audio;

      // Set volume before playing
      audio.volume = volume;

      audio.play();
      setPlaying(true);

      audio.onended = () => {
        setPlaying(false);
        URL.revokeObjectURL(audioUrl);
      };
    } catch (error) {
      console.error("Error generating speech:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle volume change
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  return (
    <div className="relative flex items-center space-x-2">
      {/* Speaker Button */}
      <button
        onClick={handlePlay}
        className="p-2 rounded-full bg-gray-300 hover:bg-gray-400 transition-all"
        disabled={loading}
      >
        {loading ? <Loader2 className="animate-spin" /> : <Volume2 />}
      </button>

      {/* Volume Slider (Visible only when playing) */}
      {playing && (
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleVolumeChange}
          className="w-20 h-1 bg-gray-500 rounded-lg appearance-none cursor-pointer"
        />
      )}
    </div>
  );
};

export default SpeakerButton;
